const state = {
  axios_error: {},
  ws_status: {
    status: 602,
    modified: new Date().getTime() - 10 * 1000
  }
}
export default state



//////////////////
// WEBPACK FOOTER
// ./state/error/error.state.js
// module id = null
// module chunks = 